import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import CreateMenu from "../views/CreateMenu.vue";
import IndividualGame from "../views/IndividualGame.vue";
import Creating from "../views/Creating.vue";
import RulesPage from "../views/RulesPage.vue";
import AboutPage from "../views/AboutPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/creategame",
    name: "CreateMenu",
    component: CreateMenu,
    props: true
  },
  {
    path: "/loading",
    name: "Creating",
    component: Creating,
    props: true
  },
  {
    path: "/game/:gameName",
    name: "IndividualGame",
    component: IndividualGame,
    props: true
  },
  {
    path: "/rules",
    name: "RulesPage",
    component: RulesPage
  },
  {
    path: "/about",
    name: "AboutPage",
    component: AboutPage
  }
];

const router = new VueRouter({
  routes
});

export default router;
